import { InstructorUserRequest, UserCalorie } from "pages";
import instructorRouteMap from "routeControl/instructorRouteMap";

/**
 * Generates an array of route objects for the admin dashboard.
 * @returns {Array} An array containing the route object for the admin dashboard.
 */
export default function route() {
  return [
    {
      path: instructorRouteMap.USER_REQUEST.path, // URL path for the dashboard
      name: "Access Request", // Display name for the route
      key: instructorRouteMap.USER_REQUEST.path, // Unique key for the route
      private: true, // Requires authentication to access
      belongsToSidebar: true, // Appears in the admin sidebar
      icon: instructorRouteMap.USER_REQUEST.icon, // Icon associated with the dashboard
      element: <InstructorUserRequest />, // Component to render for this route
    },
    {
      path: instructorRouteMap.USER_CALORIE_LOGS_INSTRUCTOR.path, // URL path for the dashboard
      name: "Access Request", // Display name for the route
      key: instructorRouteMap.USER_CALORIE_LOGS_INSTRUCTOR.path, // Unique key for the route
      private: true, // Requires authentication to access
      belongsToSidebar: false, // Appears in the admin sidebar
      element: <UserCalorie />, // Component to render for this route
    },
  ];
}
